export default {"src":"/_next/static/media/RightArrow.cb924497.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};